
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes05 as ObiDiodes05Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-05.js';
 
 
 

 
 export const ObiDiodes05 = createComponent({
   react: React,
   tagName: 'obi-diodes-05',
   elementClass: ObiDiodes05Element,
   events: {
     
   }
  });
 
 